import * as angular from 'angular';
import { saveAs } from 'file-saver/FileSaver';
import { EnumService } from './enum.service';

export class TransferFileService {
    public static $inject = ['$q', '$timeout', 'enumService'];
    private readonly withBOM = '\uFEFF';
    constructor(
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private enumService: EnumService
    ) { }

    public transferFile(fileData: string, filename: string, type : number = this.enumService.ExportFileType.CSV) {
        if (!fileData) {
            return;
        }

        if (!filename) {
            const d = new Date();
            filename = d.getFullYear() + '_' + d.getMonth() + '_' + d.getDate() + '_' + d.getHours() + '_' + d.getMinutes() + '_' + d.getSeconds();
        }
        let blob;
        if (type === this.enumService.ExportFileType.CSV) {
            filename = filename.replace(/\.csv$/i, '') + '.csv';
            blob = new Blob([this.withBOM, fileData], { type: 'text/csv;charset=utf-8;' });
        } else if (type === this.enumService.ExportFileType.PDF) {
            filename = filename.replace(/\.pdf$/i, '') + '.pdf';
            blob = new Blob([fileData], { type: 'application/pdf' });
        } else if (type === this.enumService.ExportFileType.ZIP) {
            filename = filename.replace(/\.zip$/i, '') + '.zip';
            blob = new Blob([fileData], {type: 'application/zip'});
        } else if (type === this.enumService.ExportFileType.EPUB) {
            filename = filename.replace(/\.epub$/i, '') + '.epub';
            blob = new Blob([fileData], {type: 'application/epub+zip'});
        } else if (type === this.enumService.ExportFileType.SVG) {
            filename = filename.replace(/\.svg$/i, '') + '.svg';
            blob = new Blob([fileData], { type: 'image/svg+xml;charset=utf-8' });
        } else {
            return;
        }

        if (type === this.enumService.ExportFileType.CSV) {
            const downloadAttrSupport = 'download' in document.createElement('a');
            if (downloadAttrSupport && (/chrome/i).test(window.navigator.userAgent)) {
                const linkElement = angular.element('<a/>');
                linkElement.attr({
                    href: URL.createObjectURL(blob),
                    target: '_blank',
                    download: filename
                })[0].click();
                this.$timeout(() => {
                    linkElement.remove();
                  }, 500);
                return;
            } else if ((/safari/i).test(window.navigator.userAgent)) {

                let versionArray = window.navigator.userAgent.split('Version/');
                let version: number;
                if (versionArray && versionArray[1]) {
                    versionArray = versionArray[1].split(' ');
                }

                if (versionArray && versionArray[0]) {
                    versionArray = versionArray[0].split('.');
                }

                if (versionArray && versionArray[0]) {
                    version = +versionArray[0];
                }

                if (!isNaN(version) && version < 10) {
                    window.open(`data:attachment/csv;charset=utf-8,${this.withBOM}` + encodeURI(fileData));
                    return;
                }

                const link = window.document.createElement('a');
                link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(fileData));
                link.setAttribute('download', filename);
                setTimeout(() => {
                    link.remove();
                }, 500);

            }
        }

        saveAs(blob, filename);
    }
}

angular.module('app.common').service('transferFileService', TransferFileService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/transferFile.service.ts